// client/src/components/configuracoes/acessoSuporte/AcessoSuporteConfigPage.js
import React from 'react';
import { ShieldCheck, ShieldOff, Loader2, Clock } from 'lucide-react';
import PageHeader from '../../layout/PageHeader';
import { useSupportAccessStatus, useGrantSupportAccess, useRevokeSupportAccess } from '../../../hooks/useSupportAccess';

const DURACOES = [
    { horas: 1, label: '1 hora' },
    { horas: 4, label: '4 horas' },
    { horas: 24, label: '24 horas' },
];

const formatarData = (data) => new Date(data).toLocaleString('pt-BR', {
    day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'
});

const AcessoSuporteConfigPage = () => {
    const { data: grant, isLoading } = useSupportAccessStatus();
    const grantMutation = useGrantSupportAccess();
    const revokeMutation = useRevokeSupportAccess();

    const ativo = !!grant && grant.status === 'ativo' && new Date(grant.expiresAt) > new Date();

    return (
        <div className="page-management-container">
            <PageHeader
                icon={<ShieldCheck />}
                title="Acesso de Suporte"
                subtitle="Libere temporariamente que a equipe Onmicare acesse sua conta para ajudar em um atendimento"
            />

            <div className="content-panel">
                <div className="form-section">
                    <h4 className="form-section-title">Status atual</h4>

                    {isLoading ? (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', color: 'var(--color-text-secondary)' }}>
                            <Loader2 size={18} className="icon animate-spin" /> Carregando...
                        </div>
                    ) : ativo ? (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', flexWrap: 'wrap' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', color: '#16A34A', fontWeight: 600 }}>
                                <ShieldCheck size={18} className="icon" />
                                Acesso de suporte ativo
                            </div>
                            <span style={{ color: 'var(--color-text-secondary)', fontSize: '0.9rem' }}>
                                <Clock size={14} className="icon" style={{ verticalAlign: 'middle', marginRight: '0.25rem' }} />
                                Expira em {formatarData(grant.expiresAt)}
                            </span>
                            <button
                                type="button"
                                className="action-button action-button-danger"
                                onClick={() => revokeMutation.mutate()}
                                disabled={revokeMutation.isPending}
                            >
                                <ShieldOff size={18} className="icon" />
                                {revokeMutation.isPending ? 'Revogando...' : 'Revogar agora'}
                            </button>
                        </div>
                    ) : (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', color: 'var(--color-text-secondary)' }}>
                            <ShieldOff size={18} className="icon" />
                            Nenhum acesso de suporte ativo no momento
                        </div>
                    )}
                </div>

                <div className="form-section">
                    <h4 className="form-section-title">
                        {ativo ? 'Estender ou trocar a duração' : 'Habilitar acesso de suporte'}
                    </h4>
                    <p style={{ fontSize: '0.85rem', color: 'var(--color-text-secondary)', marginTop: 0, marginBottom: '0.75rem' }}>
                        Enquanto estiver ativo, administradores autorizados da Onmicare podem acessar sua conta
                        para diagnosticar ou resolver um chamado de suporte. Você pode revogar a qualquer momento
                        e cada acesso fica registrado no histórico de atividades.
                    </p>
                    <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
                        {DURACOES.map((d) => (
                            <button
                                key={d.horas}
                                type="button"
                                className="action-button action-button-primary"
                                onClick={() => grantMutation.mutate(d.horas)}
                                disabled={grantMutation.isPending}
                            >
                                {grantMutation.isPending ? 'Habilitando...' : `Habilitar por ${d.label}`}
                            </button>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AcessoSuporteConfigPage;
